import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';
import {
  ClarityService,
  CookieConsentComponent,
  GtagService,
} from '@nomoh-monorepo/data-access-shared-analytics';
import { ENVIRONMENT_TOKEN } from '@nomoh-monorepo/shared-data-access-environment';

@Component({
  standalone: true,
  imports: [RouterModule, TranslateModule, ToastModule, CookieConsentComponent],
  selector: 'app-root',
  template: `<p-toast position="top-center" [baseZIndex]="99999" [breakpoints]="{'920px':{width:'90vw'}}" showTransformOptions="translateY(-100%)" hideTransformOptions="translateY(-100%)" showTransitionOptions="300ms ease-out" hideTransitionOptions="200ms ease-in"></p-toast><lib-cookie-consent /><router-outlet></router-outlet>`,
})
export class AppComponent {
  constructor() {
    const env = inject(ENVIRONMENT_TOKEN);
    inject(ClarityService).init(
      env.analytics.clarityIds.nomohCliente,
      env.analytics.clarityEnabled
    );
    inject(GtagService).init(
      env.analytics.googleAdsId,
      env.analytics.googleAdsEnabled
    );
  }
}
